export const COLORS = {
  primary_purple: '#813EA1',
  light_purple: '#9B59CC',
  white: '#FFFFFF',
  background: '#F8F9FF',
  gray01: '#EEEFF2',
  gray02: '#718096',
  gray03: '#D1D9E0',
  blue: '#BFDAF7',
  skyblue: '#D4E4F4',
}
